<admin-layout [showSearch]="false" [showMenu]="false" [showActionBar]="false">
    @if (producer) {
    <header class="producer-bar">
        <button type="button" class="back" (click)="goBack()" aria-label="Voltar">
            <mat-icon>west</mat-icon>
        </button>
        <div class="producer-avatar" aria-hidden="true">{{ producerInitials }}</div>
        <div class="producer-meta">
            <h1>{{ producer.name }}</h1>
            <p>
                <span class="code">{{ producer.code }}</span>
                @if (contactLines.length) {
                <span class="dot">·</span>
                <span class="chip-info" [title]="contactLines[0].label">{{ contactLines[0].value }}</span>
                }
                @if (contactLines.length > 1) {
                <span class="chip-more">+{{ contactLines.length - 1 }}</span>
                }
            </p>
        </div>
        @if (addressLines.length) {
        <div class="producer-extra" [title]="addressLines.join('\n')">
            <span class="extra-title">Endereço</span>
            <span class="extra-line">{{ addressLines[0] }}</span>
            @if (addressLines.length > 1) {
            <span class="extra-muted">+{{ addressLines.length - 1 }} endereço(s)</span>
            }
        </div>
        }
    </header>
    }

    <mat-tab-group
        mat-stretch-tabs
        class="producer-tabs"
        [(selectedIndex)]="selectedTab"
        (selectedIndexChange)="onTabSelected($event)"
    >
        <mat-tab label="Usuários">
            <ng-template matTabContent>
                @if (producer) {
                <homeleite-producer-details-users
                    [entity]="producer"
                    [associatedUsers$]="associatedUsers$"
                    (usersChanged)="loadAssociatedUsers()"
                ></homeleite-producer-details-users>
                }
            </ng-template>
        </mat-tab>
        <mat-tab label="Animais">
            <ng-template matTabContent>
                @if (producer) {
                <homeleite-producer-details-animals
                    [producer]="producer"
                ></homeleite-producer-details-animals>
                }
            </ng-template>
        </mat-tab>
        <mat-tab label="Controles">
            <ng-template matTabContent>
                @if (producer) {
                <homeleite-producer-details-milk-controls
                    [producer]="producer"
                ></homeleite-producer-details-milk-controls>
                }
            </ng-template>
        </mat-tab>
        <mat-tab label="Sincronização">
            <ng-template matTabContent>
                <homeleite-producer-details-synchronize
                    [entity]="producer"
                ></homeleite-producer-details-synchronize>
            </ng-template>
        </mat-tab>
        <mat-tab label="Logs">
            <ng-template matTabContent>
                @if (producer) {
                <homeleite-producer-details-logs
                    [producer]="producer"
                ></homeleite-producer-details-logs>
                }
            </ng-template>
        </mat-tab>
    </mat-tab-group>
</admin-layout>
